import { combineReducers } from "redux";
import errorReducer from "./ErrorResponse/Reducer";
import renewalReducer from "./PolicyNumber/reducer";
import appointmentReducer from "./AppointmentDetails/reducer";
import bookVisitReducer from "./BookMedicalVisit/reducer";
import teleUwReducer from "./BookTeleMedical/reducer";
import teleAppointmentReducer from "./TeleAppointmentDetails/reducer";

// add reducers here
const rootReducer = combineReducers({
    trackPolicyDetails: renewalReducer,
    appointmentDetails: appointmentReducer,
    bookVisitDetails: bookVisitReducer,
    teleAppointmentDetails: teleAppointmentReducer,
    teleUwDetails: teleUwReducer,
    error:errorReducer
});

export default rootReducer;
